import { jsx as _jsx } from "react/jsx-runtime";
const CircularProgress = ({ className }) => (_jsx("div", Object.assign({ className: `loader ${className}` }, { children: _jsx("img", { src: "/assets/images/loader.svg", alt: "loader" }) })));
export default CircularProgress;
